import { InviteFriendsScreens } from '../InviteFriendsComponent.types';
import { TabsSectionItem } from './TabsSection.types';

export const TabSectionItems: TabsSectionItem[] = [
  { locKey: 'tab_InviteFriends', screen: InviteFriendsScreens.INVITE_FRIENDS },
  { locKey: 'tab_Terms', screen: InviteFriendsScreens.TERMS },
];

export const TAB_HEIGHT = 32;
export const TAB_MIN_WIDTH = 109;
